export default ({ db }) => {
  const ref = ({ userId, bookId }) => db.ref(`/userbooks/${userId}/${bookId}`)

  return {
    ref,
    get: ({ userId, bookId }) =>
      new Promise((resolve) => {
        ref({ userId, bookId }).once('value', (snap) => {
          const value = snap.val()
          resolve(value ? { '.key': snap.key, ...snap.val() } : null)
        })
      }),
    update: ({ userId, bookId }, value) => {
      return ref({ userId, bookId }).update(value)
    },
    delete: ({ userId, bookId }) => {
      return ref({ userId, bookId }).remove()
    },
    hasReview: (book) => book.review || book.reviewUrl
  }
}
